import * as React from 'react';
import { LoginByPasswordSkeletonTrackingUtils } from '@shopee-user/business-customization-types';

// HoC & Hooks & Utils
import { useTranslation, config } from '@shopee-user/platform';
import { compose } from 'redux';
import {
  withUserWebView,
  WithUserWebViewProps,
} from '@shopee-user/with-web-view';

// Components
import Navbar from '../../../Navbar';
import { AuthenticationHelpButton } from '../../../NavbarHelpButton';

type OwnProps = {
  shouldHideBack: boolean;
};
type Props = OwnProps &
  WithUserWebViewProps &
  LoginByPasswordSkeletonTrackingUtils;

function Header({
  shouldHideBack,
  // withUserWebViewProps
  webViewNavigateBack,
  // TrackingUtils
  trackingUtils,
}: Props) {
  const I18n = useTranslation();
  return (
    <Navbar
      title={I18n.t('label_auth_log_in', { context: config.BUSINESS_TARGET })}
      onClickBack={() => {
        trackingUtils.trackClickBackButton?.();
        webViewNavigateBack();
      }}
      rightContent={
        <AuthenticationHelpButton
          text={I18n.t('label_auth_help')}
          onClick={() => trackingUtils.trackClickHelpButton?.()}
        />
      }
      shouldHideBack={shouldHideBack}
    />
  );
}

export default compose<React.ComponentType<OwnProps>>(withUserWebView({}))(
  Header
);
